module.exports = __webpack_public_path__ + "img/layout.a9323ceb.svg";